import { JoonUIColor, Loader, SPACING, Typography } from "@joonapp/web-shared"
import { useState } from "react"
import { useTranslation } from "react-i18next"

import { getAfterAuthPath } from "./ForgotPassword"
import { useAccountCreation } from "../../hooks/useAccountCreation"
import {
  signUpWithGoogle,
  signInWithGoogle,
} from "../../networking/authentication"
import { AlertInterface } from "../../types"
import { useRouter } from "../../util/router"

interface Props {
  type: "signin" | "signup"
  setFormAlert?: (alert: AlertInterface) => void
}

function GoogleAuth({ setFormAlert = () => {}, type }: Props) {
  const [pending, setPending] = useState(false)
  const { uploadOnboardingSecondaryData } = useAccountCreation()
  const { t } = useTranslation()

  const router = useRouter()

  const onSigninWithProvider = async () => {
    setPending(true)
    try {
      await signInWithGoogle()
      router.push(getAfterAuthPath(router))
    } catch (err) {
      // This is assuming that the error is because the user does not exist
      setFormAlert({
        type: "error",
        message: t("AUTH_USER_DOES_NOT_EXIST"),
      })
    } finally {
      setPending(false)
    }
  }

  const onSignUpWithProvider = async () => {
    setPending(true)
    try {
      await signUpWithGoogle()
      uploadOnboardingSecondaryData()
    } catch (error) {
    } finally {
      setPending(false)
    }
  }

  return (
    <GoogleAuthButton
      onClick={type === "signin" ? onSigninWithProvider : onSignUpWithProvider}
      isLoading={pending}
      type={type}
    />
  )
}

export const GoogleAuthButton = ({
  onClick,
  isLoading,
  type,
}: {
  onClick: () => void
  isLoading: boolean
  type: "signin" | "signup"
}) => {
  const { t } = useTranslation()
  const text =
    type === "signin"
      ? t("AUTH_SIGNIN_WITH_GOOGLE")
      : t("AUTH_SIGNUP_WITH_GOOGLE")
  return (
    <button
      type="submit"
      disabled={isLoading}
      onClick={onClick}
      style={{
        borderRadius: SPACING.space2,
        width: "100%",
        display: "flex",
        alignItems: "center",
        border: `1px solid ${JoonUIColor.border.accent}`,
        position: "relative",
        textAlign: "center",
        justifyContent: "center",
        padding: `10px ${SPACING.space4}`,
        background: "white",
      }}
    >
      <div
        style={{
          position: "absolute",
          alignItems: "center",
          display: "inline-flex",
          justifyContent: "center",
          width: "1.5em",
          height: "1.5em",
          left: SPACING.space4,
        }}
      >
        <img
          src={`https://uploads.divjoy.com/icon-google.svg`}
          alt={"Google"}
          style={{ display: "block", width: "100%" }}
        />
      </div>
      {isLoading ? (
        <Loader color={JoonUIColor.background.accent} size={24} thickness={2} />
      ) : (
        <Typography variant="body" color={JoonUIColor.text.primary}>
          {text}
        </Typography>
      )}
    </button>
  )
}

export default GoogleAuth
